import { render, staticRenderFns } from "./right.vue?vue&type=template&id=cec484b4&scoped=true&"
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=cec484b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec484b4",
  null
  
)

export default component.exports